export default __webpack_public_path__ + "static/media/profile.a37f5f0d.png";